module.exports = __webpack_public_path__ + "media/images/panganight-aea910907f01f86fb9e3c8f1bd9603bf.png";